<template>
        <b-modal :size="size" :title="caption" v-model="dataShow" :hide-footer="true">
            <Request
                    ref="requestPreview"
                    method="GET"
                    root="/invoice/preview"
                    @onInit="onInit"
                    :onRequestSuccess="onRequestPreviewSuccess">
                <slot slot="body">
                    <div v-html="dataPreview"></div>
                </slot>
            </Request>
            <hr/>
            <b-row>
                <b-col>
                    <b-button-group>
                        <b-button @click="printOnClick" class="btn btn-light"><i class="fa fa-print mr-2"></i>{{Core.Definition.getDefinition('Ouvrir pour imprimer')}}</b-button>
                    </b-button-group>
                </b-col>
                <b-col class="text-right">
                    <Request
                            ref="requestSend"
                            :options="{
                                        showAlert: true,
                                        blockOnProcessing: false,
                                        blockTransparent: false
                            }"
                            method="POST"
                            root="/invoice/send"
                            :onRequestSuccess="onRequestSendSuccess">
                        <slot slot="body">
                            <b-button-group>
                                <b-input v-model="dataSend.recipient" :placeholder="Core.Definition.getDefinition('Destinataire')" type="text"></b-input>
                                <b-button :disabled="dataSend.processing" @click="sendOnClick" class="btn btn-edit"><i :class="{'fa-send': dataSend.processing === false, 'fa-spinner fa-spin': dataSend.processing}" class="fa"></i></b-button>
                            </b-button-group>
                        </slot>
                    </Request>

                </b-col>
            </b-row>
        </b-modal>
</template>

<script>
    import Request from './Request'
    import Vue from 'vue'
    export default {
      name: 'ModalInvoice',
      components: {
          Request
      },
      props: {
          size: {
              type: String,
              default: 'lg'
          },
          okTitle: {
              type: String,
              default: 'Ok'
          },
          caption: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
        computed: {
            instanceId: {
                set(val) {
                    this.dataInstanceId = val
                },
                get() {
                    return this.dataInstanceId
                }
            },
            instanceType: {
                set(val) {
                    this.dataInstanceType = val
                },
                get() {
                    return this.dataInstanceType
                }
            },
            email: {
                set(val) {
                    this.dataSend.recipient = val
                },
                get() {
                    return this.dataSend.recipient
                }
            },
            open: {
                set(val) {
                    this.dataShow = val
                },
                get() {
                    return this.dataShow
                }
            },
            disableOk: {
                set(val) {
                    this.dataOkDisabled = val
                },
                get() {
                    return this.dataOkDisabled
                }
            }
        },
      mounted() {
      },
      data: () => {
          return {
              Core: window.Core,
              dataShow: false,
              dataPreview: '',
              dataInstanceId: '',
              dataInstanceType: '',
              dataSend: {
                  recipient: '',
                  processing: false
              },
              dataPDF: {
                  processing: false
              },
          }
      },
      methods: {
          onInit() {
              this.$refs.requestPreview.clearArgs()
              this.$refs.requestPreview.addArg('instanceId', this.dataInstanceId)
              this.$refs.requestPreview.addArg('instanceType', this.dataInstanceType)
              this.$refs.requestPreview.request()
          },
          PDFOnClick() {
              this.dataPDF.processing = true
              this.$refs.requestPDF.clearArgs()
              this.$refs.requestPDF.addArg('instanceId', this.dataInstanceId)
              this.$refs.requestPDF.addArg('instanceType', this.dataInstanceType)
              this.$refs.requestPDF.addArg('recipient', this.dataSend.recipient)
              this.$refs.requestPDF.request()
          },
          printOnClick() {
              let print = window.open('', '_blank');
              print.document.write(this.dataPreview);
              print.print()
          },
          sendOnClick() {
              if (this.dataSend.recipient !== '') {
                  this.dataSend.processing = true
                  this.$refs.requestSend.clearArgs()
                  this.$refs.requestSend.addArg('instanceId', this.dataInstanceId)
                  this.$refs.requestSend.addArg('instanceType', this.dataInstanceType)
                  this.$refs.requestSend.addArg('recipient', this.dataSend.recipient)
                  this.$refs.requestSend.request()
              }
          },
          onRequestPDFSuccess(data) {
              this.dataPDF.processing = false
          },
          onRequestSendSuccess(data) {
              this.dataSend.recipient = ''
              this.dataSend.processing = false
          },
          onRequestPreviewSuccess(data) {
              if (data.preview !== undefined) {
                  this.dataPreview = data.preview
              }
          }
      }
  }
</script>